import React from 'react';
import icon_newpost_images from '../../../../assets/icons/icon_newpost_images.svg';
import icon_newpost_camera from '../../../../assets/icons/icon_newpost_camera.svg';
import icon_newpost_gif from '../../../../assets/icons/icon_newpost_gif.svg';

interface ModalFooterProps {
  onMediaUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onCameraCapture: () => void;
  onGifClick: () => void;
  isPostButtonEnabled: boolean;
  isPosting: boolean;
  onPost: () => void;
  customMediaUploadButton?: React.ReactNode;
}

const ModalFooter: React.FC<ModalFooterProps> = ({
  onMediaUpload,
  onCameraCapture,
  onGifClick,
  isPostButtonEnabled,
  isPosting,
  onPost,
  customMediaUploadButton
}) => {
  return (
    <div className="modal-footer">
      <div className="media-input-group">
        {customMediaUploadButton ? (
          customMediaUploadButton
        ) : (
          <>
            <input
              id="media-upload"
              type="file"
              accept="image/*, video/mp4, video/quicktime"
              multiple
              onChange={onMediaUpload}
              style={{ display: 'none' }}
            />
            <label htmlFor="media-upload">
              <img src={icon_newpost_images} alt="Upload Media" />
            </label>
          </>
        )}
        <img src={icon_newpost_camera} alt="Camera" onClick={onCameraCapture} />
        <img src={icon_newpost_gif} alt="GIF" onClick={onGifClick} />
      </div>
      <button
        className={`post-button ${isPostButtonEnabled ? 'enabled' : ''}`}
        disabled={!isPostButtonEnabled || isPosting}
        onClick={onPost}
      >
        {isPosting ? 'Posting...' : 'Post'}
      </button>
    </div>
  );
};

export default ModalFooter; 